import {
    ITopicHeaders,
    MessageBroker,
    PostLoginActionNameEnum,
    PlayerChannel,
} from '@sparkware/uc-sdk-core';
import { IPostLoginActionsState, IShowKYCPostLoginOptions } from '../models/IPostLoginActionsState';
import { PostLoginActionBase } from './post-login-action-base';

const MB_HEADER: ITopicHeaders = { publisher: 'OpenKYCPostLoginAction' };

export class OpenKYCPostLoginAction extends PostLoginActionBase {
    private _playerChannel: PlayerChannel;

    constructor(state: IPostLoginActionsState) {
        super(PostLoginActionNameEnum.ShowKYC, 'OpenKYCPostLoginAction', state);
        this._playerChannel = MessageBroker.getInstance().player;
    }

    protected override canExecute = (options?: IShowKYCPostLoginOptions): Promise<boolean> => {
        const kycOpenRequired = options?.enabled || false;

        return Promise.resolve(kycOpenRequired);
    };

    protected override doAction = async (): Promise<boolean> => {
        this.clearOptions();
        this._playerChannel.topics.CTA_MyAccount_Open.publish(MB_HEADER, {
            tabId: 18,
            hideHeader: true,
            hideMenu: true,
            showInAppCloseButton: true,
            onClose: this.completeAction,
        });
        return false;
    };
}
